// extracted by mini-css-extract-plugin
module.exports = {"root":"Photos_root__1T_xs","formTitleContainer":"Photos_formTitleContainer__n90oN","formTitle":"Photos_formTitle__3MBhR","formItemContainer":"Photos_formItemContainer__3zF-S"};